/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Route } from "react-router-dom";
import { QuickSearchValueContext } from "../../../../../../app/icomos/context/quickSearch";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

export function SearchResult({ data, searchValue }) {
  const { setValue } = useContext(QuickSearchValueContext);

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <div
        style={{ maxHeight: "325px", overflow: "hidden" }}
        className="quick-search-wrapper scroll ps ps--active-y"
      >
        <div className="quick-search-result">
          <div className="text-muted d-none">Внесот не постои</div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ maxHeight: "325px", overflow: "hidden" }}
      className="quick-search-wrapper scroll ps ps--active-y"
    >
      <PerfectScrollbar
        options={perfectScrollbarOptions}
        className="scroll"
        style={{ maxHeight: "325px", position: "relative" }}
      >
        <div className="quick-search-result">
          {/* begin: Section */}
          <div className="font-size-sm text-primary font-weight-bolder text-uppercase mb-2">
            Обрасци
          </div>
          <div className="mb-10">
            {data.map((obrazec) => (
              <Route
                key={obrazec.id}
                render={({ history }) => (
                  <div
                    className="d-flex align-items-center flex-grow-1 mb-2"
                    style={{ cursor: "pointer" }}
                    key={obrazec.id}
                    onClick={() => {
                      history.push(`/churches/${obrazec.id}/view`);
                    }}
                  >
                    <div className="symbol symbol-45 bg-transparent flex-shrink-0">
                      <img src={obrazec.media} alt={obrazec.naziv} />
                    </div>
                    <div className="d-flex flex-column ml-3 mt-2 mb-2">
                      <a
                        href="#"
                        className="font-weight-bold text-dark text-hover-primary"
                      >
                        {obrazec.naziv}
                      </a>
                      <span className="font-size-sm font-weight-bold text-muted">
                        {obrazec.opstina}
                      </span>
                    </div>
                  </div>
                )}
              />
            ))}
          </div>
          {/* end: Section */}

          {/* begin: Section */}
          <Route
            render={({ history }) => (
              <div
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setValue(searchValue);
                  history.push("/maps");
                }}
                className="font-size-sm text-primary font-weight-bolder text-uppercase mb-2"
              >
                Сите
              </div>
            )}
          />
          {/* end: Section */}
        </div>
      </PerfectScrollbar>
    </div>
  );
}
